import ScoutingAnalysisPage from "@/pages/scouting/page";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteUrl } from "@/configs/router/routes";

export const Route = createFileRoute("/_pathlessLayout/scouting")({
    component: ScoutingAnalysisPage,
    beforeLoad: ({ location }) => {
        if (location.pathname === RouteUrl.Scouting) {
            throw redirect({ to: RouteUrl.ScoutingPlayers });
        }
    },
});
